<template>
    <div class="commonDetail">
        <div class="logo" v-if="!thirdParty"></div>
        <div class="title" v-if="!thirdParty">{{ title }}</div>
        <div class="content" v-for="item in imgList" :key="item.id">
            <img :src="item.imgUrl | transImgUrl" alt />
        </div>
        <a :href="`tel:${phoneNumber}`">
            <div class="phone" v-if="hasPhone">
                <img src="@/assets/images/phone.png" alt />
                电话咨询
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "commonDetail",
    props: {
        hasPhone: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        imgList: {
            type: Array
        },
        phoneNumber: {
            type: String
        },
        thirdParty: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.commonDetail {
    padding-bottom: 50px;
    .logo {
        width: 100%;
        height: 150px;
        background: url("~@/assets/images/police.png");
        background-size: contain;
    }
    .title {
        margin-top: 24px;
        opacity: 1;
        font-size: 19px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffd63c;
        line-height: 28px;
        text-shadow: 1px 1px 1px 0px rgba(4, 29, 61, 0.2);
        margin-bottom: 20px;
    }
    .content {
      
        img {
            width: 100%;
        }
    }
    .phone {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 49px;
        opacity: 1;
        background: #ffd63c;
        opacity: 1;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #543302;
        text-align: center;
        line-height: 49px;

        img {
            width: 24px;
            height: 24px;
            opacity: 1;
            margin-right: 10px;
            vertical-align: bottom;
            margin-bottom: 12px;
        }
    }
}
</style>
